
<template>
    <BModal :model-value="modal" scrollable centered @update:modelValue="updateModal" >
        <template #header>
            <div class="d-flex align-items-center justify-content-between modal-title w-100">
                <h5 class="">Destination</h5>
            </div>
            <BButton
                variant="link"
                class="close"
                @click="updateModal(false)"
            >
                <i class="ion ion-android-close"></i>
            </BButton>
        </template>

        <BForm>
            <BContainer>
                
                <BRow>
                    <BCol>
                        <BFormInput type="text" id="input-1" :model-value="data.code" @update:modelValue="updateModalEdit" placeholder="Code"  class="form-group" />
                    </BCol>
                    <BCol>
                        <BFormInput type="text" id="input-1" :model-value="data.place_name"  @update:modelValue="updateModalEdit"  :state="state" placeholder="Name" class="form-group" />
                    </BCol>
                </BRow>
                <BRow >
                    
                </BRow>
                
                
                
            </BContainer>
            
                
        
        </BForm>
        <template #footer>
            <div class="d-flex justify-content-end">
                <BButton variant="primary" @click="alertData"  class="mr-2">Save</BButton>
                <BButton variant="danger" @click="updateModal(false)">Cancel</BButton>
            </div>
        </template>
    </BModal>
</template>

<script>
import { BModal,BRow, BCol, BForm, BFormInput, BButton } from 'bootstrap-vue-next';
import { reactive } from 'vue'


export default{
    name : 'EditDestination',
    components : { BModal,BRow, BCol, BForm, BFormInput, BButton },
    props : {
        modal : Boolean,
        data : Object
    },
    setup(props, {emit}){
        const tes = reactive({...props.data})
        const updateModal = (value) => {
            emit("update:modal", value); // Sync modal state with parent
        };
        const updateModalEdit = (value) => {
            emit("update:data", value); // Sync modal state with parent
            
        };
        const alertData = ()=>{
            console.log(tes)
        }
        return {
            updateModal,
            updateModalEdit,
            alertData,
            tes,

        }
    }
}
</script>


